import React from 'react';
import TablePagination from '@material-ui/core/TablePagination';

const KobooTablePagination = ({
  numberOfItems,
  rowsPerPage,
  label,
  page,
  onChangePage,
  onChangeRowsPerPage,
}) =>
    <div>
        <TablePagination
            component="div"
            count={numberOfItems}
            rowsPerPage={rowsPerPage}
            rowsPerPageOptions={[500, 800, 1000]}
            labelRowsPerPage={label}
            page={page}
            backIconButtonProps={{
                'aria-label': 'Previous Page',
            }}
            nextIconButtonProps={{
                'aria-label': 'Next Page',
            }}
            onPageChange={onChangePage}
            onRowsPerPageChange={onChangeRowsPerPage}
        />
    </div>;

export default KobooTablePagination;



// WEBPACK FOOTER //
// ./src/components/Layout/KobooTablePagination.jsx